import { Injectable } from '@angular/core';
import { RowUpdatingEvent } from 'devextreme/ui/data_grid';
import { Agent, AgentKeys, Registrant, RegistrantModelKeys, Role } from 'ag-common-lib/public-api';
import { mergeMap, Observable, shareReplay } from 'rxjs';
import { AttendeeDetailsModalService } from '../attendee-details-modal.service';
import { ConferenceRegistrationLogsService } from 'ag-common-svc/lib/services/conference-registration-logs.service';
import {
  ConferenceRegistrationLog,
  ConferenceRegistrationLogKeys,
} from 'ag-common-lib/lib/models/registration/registrant-notes';
import { AgentService } from 'ag-common-svc/lib/services/agent.service';
import { LoadOptions } from 'devextreme/data';
import { AgentSearchService } from 'ag-common-svc/lib/services/agent-search';
import DataSource from 'devextreme/data/data_source';
import { BaseModelKeys } from 'ag-common-lib/lib/models/base.model';

@Injectable()
export class AttendeeNotesService {
  registrantNotes$: Observable<ConferenceRegistrationLog[]>;
  agentsDataSource: DataSource;

  private _conferenceDbId: string;
  get conferenceDbId() {
    return this._conferenceDbId;
  }

  private _registrantDbId: string;
  get registrantId() {
    return this._registrantDbId;
  }

  protected readonly agentsLoadOptions: LoadOptions<Agent> = {
    filter: [{ terms: { [AgentKeys.role]: [Role.CONFERENCE_MANAGER] } }],
  };

  constructor(
    private conferenceRegistrationLogsService: ConferenceRegistrationLogsService,
    private attendeeDetailsModalService: AttendeeDetailsModalService,
    private agentSearchService: AgentSearchService,
    private agentService: AgentService,
  ) {
    this.registrantNotes$ = this.attendeeDetailsModalService.registrant$.pipe(
      mergeMap((conferenceRegistration: Registrant) => {
        this._conferenceDbId = conferenceRegistration?.[RegistrantModelKeys.conferenceDbId];
        this._registrantDbId = conferenceRegistration?.[BaseModelKeys.dbId];

        return this.conferenceRegistrationLogsService.getList(this._conferenceDbId, this._registrantDbId);
      }),
      shareReplay(1),
    );

    this.agentsDataSource = this.agentSearchService.getDataSource(this.agentsLoadOptions);
  }

  onNoteUpdating = (e: RowUpdatingEvent) => {
    const registrationLog: ConferenceRegistrationLog = e.oldData;
    const updates: ConferenceRegistrationLog = e.newData;
    const registrantNoteDbI = registrationLog?.[BaseModelKeys.dbId];

    e.cancel = this.conferenceRegistrationLogsService
      .update(this._conferenceDbId, this._registrantDbId, registrantNoteDbI, updates, true)
      .then(() => undefined);
  };

  archive = (registrantNoteDbI: string) => {
    const updates = { [ConferenceRegistrationLogKeys.isArchived]: true };

    this.conferenceRegistrationLogsService
      .update(this._conferenceDbId, this._registrantDbId, registrantNoteDbI, updates, true)
      .then(() => undefined);
  };

  revertArchive = (registrantNoteDbI: string) => {
    const updates = { [ConferenceRegistrationLogKeys.isArchived]: false };

    this.conferenceRegistrationLogsService
      .update(this._conferenceDbId, this._registrantDbId, registrantNoteDbI, updates, true)
      .then(() => undefined);
  };
}
